window.addEventListener('DOMContentLoaded', function () {
  if (document.body.classList.contains('neos-backend')) {
    document.querySelector('.c-flip-tiles')?.addEventListener('click', initBackendFlipTiles, {
      passive: true
    });
  } else {
    document.querySelectorAll('.c-flip-tile').forEach(initFlipTile);
  }
});
function initBackendFlipTiles(e) {
  const target = e.target.closest('.icon-exchange');
  const tile = e.target.closest('.c-flip-tile');
  if (target && tile) tile.classList.toggle('flip');
}
function initFlipTile(tile) {
  if (!tile) return;
  tile.addEventListener('click', () => flip(!tile.classList.contains('flip')), {
    passive: true
  });
  tile.addEventListener('mouseenter', () => flip(true, 'mouse'), {
    passive: true
  });
  tile.addEventListener('mouseleave', () => flip(false, 'mouse'), {
    passive: true
  });
  function flip(force, caller = 'click') {
    const isMobile = window.matchMedia('(hover: none)').matches;
    if (isMobile && caller !== 'click') return;
    tile.classList.toggle('flip', force);
  }
}